<template>
  <div>
    <v-select
      :items="installmentsAsSelectList"
      item-text="text"
      item-value="id"
      label="Parcelamento"
      selected
      outlined
      hide-details
      dense
      v-validate="'required'"
      :v-errors="errors"
      :error-messages="errors.collect('parcelas')"
      data-vv-name="parcelas"
      :disabled="this.disabled"
      v-model="selectedInstallment"
      @input="emitSelectedInstallment(selectedInstallment)"
    ></v-select>
    <v-card-text
      v-if="showRecurrenceMessage"
      style="color: coral; padding: 0; padding-top: 16px"
    >
      Apenas o valor da parcela vai constar no limite do seu cartão e não o
      total do curso.</v-card-text
    >
  </div>
</template>

<script>
import Util from "@/util";

export default {
  props: {
    paymentMethod: {
      required: false,
      default: "boleto",
    },
    installments: {
      required: true,
    },
    disabled: {
      default: false,
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      installmentsAsSelectList: [],
      selectedInstallment: "",
      recurrence: false,
    };
  },
  created() {
    this.generateInstallmentsAsSelectItem();
  },
  watch: {
    installments: function (newVal, oldVal) {
      this.generateInstallmentsAsSelectItem();
    },
  },
  methods: {
    generateInstallmentsAsSelectItem() {
      this.installmentsAsSelectList = [];
      this.installments.forEach((item) => {
        const totalAmount = "R$ " + Util.formatBR(item.totalAmount);
        const installmentAmount = "R$ " + Util.formatBR(item.installmentAmount);
        this.installmentsAsSelectList.push({
          id: item.quantity,
          text: `${item.quantity}x de ${installmentAmount} (${totalAmount})`,
          totalAmount: totalAmount,
          installmentAmount: item.installmentAmount,
          plan_id: item.identifier,
        });

        if (item.recurrence === true && this.recurrence === false) {
          this.recurrence = true;
        }
      });
      this.emitSelectedInstallment(this.selectedInstallment);
      if (this.installments.length === 1) {
        this.selectedInstallment = 1;
        this.emitSelectedInstallment(1);
        this.disabled = true;
      }
    },
    hasInstallments() {
      let ret = false;
      if (this.creditCard === undefined) {
        ret = true;
      }
      if (this.creditCard.installments.length === 0) {
        ret = true;
      }
      return ret;
    },

    emitSelectedInstallment(selectedInstallmentNumber) {
      const selectedInstallment = this.installments.find(
        (installment) => installment.quantity === selectedInstallmentNumber,
      );
      this.$emit("onInstallmentChange", selectedInstallment);
    },
  },

  computed: {
    showRecurrenceMessage() {
      return this.recurrence === true && this.paymentMethod === "credit_card";
    },
  },
};
</script>
